import { ProfileColor } from "../../../../dispatch/src/ProfileColor";
import { Checkbox, DataHeader, DataSource, DateRangeFilter, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProfile extends Layout {
    checkboxPayeeIdsExclude: Checkbox;
    dataheaderOfficePayrollProfile: DataHeader;
    dateRangeFilter: DateRangeFilter;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    labelOverrides: Label;
    labelPayeeTitle: Label;
    labelPaymentConfTitle: Label;
    layoutProfileColor: ProfileColor;
    panelGeneral: Panel;
    panelOverrides: Panel;
    panelPayee: Panel;
    panelPaymentConfiguration: Panel;
    panelSections: Panel;
    sourceOfficePayrollProfile: DataSource;
    textboxBonusCode: Textbox;
    textboxBonusTaxMethod: Textbox;
    textboxDescr: Textbox;
    textboxDivisionIds: Textbox;
    textboxFrozenPayables: Textbox;
    textboxId: Textbox;
    textboxJobClassCodes: Textbox;
    textboxOverrideFrequency: Textbox;
    textboxPayFrequency: Textbox;
    textboxPayRateMethod: Textbox;
    textboxPayeeIds: Textbox;
    textboxPayeeStatus: Textbox;
    textboxTerminalIds: Textbox;
}
